<template>
    <div role="tabcard" class="tab-pane active" id="projects">
        <!-- <div class="header">
            <div class="h4">
                Active Projects
                <span v-if="projects.length > 0" class="text-muted">
                    ({{ projects.length }})
                </span>
            </div>
        </div> -->

        <div v-if="loading" class="card card-default">
            <div class="card-header">
                <span class="loading-text">Loading...</span>
                <span class="loader float-right"></span>
            </div>
        </div>

        <div v-else-if="error" class="card card-default">
            <div class="card-header">
                <div class="">
                    <div><strong>Well, this is embarrassing.</strong> Something went wrong.</div>
                    <div>Please try refreshing the page, or otherwise <a href="mailto:support@sitecommandapp.com?subject=Help!">get in touch</a> and we'll be happy to help!
                    </div>
                </div>
            </div>
        </div>

        <div v-else>
            <div class="mb-2 projects-header">
                <div class="float-left">
                    <span>
                        <i class="fas fa-tools mr-1 text-muted"></i> {{numberInProgress}} {{ pluralProjects }} in progress <i class="fas fa-stop-circle ml-3 mr-1 text-muted"></i> {{numberNotStarted}} not started
                    </span>
                </div>
                <div class="float-right">
                     <span :class="expand ? 'link' : 'text-muted'" @click="clickedCompact">Compact view</span> | <span :class="!expand ? 'link' : 'text-muted'" @click="clickedExpand">Expanded view</span>
                </div>
            </div>
            <div v-if="!loading && projects.length == 0">
                <project-form :role="role"></project-form>
            </div>
            <project v-else v-for="project in projects" :role="role" :project="project" :key="project.id" :expand="expand"></project>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['role', 'user'],

        created: function() {
            this.registerEvents();
            this.getProjects();
        },

        mounted: function() {

        },

        data: function() {
            return {
                projects: [],
                loading: true,
                error: false,
                expand: false,
                numberInProgress: 0,
                numberNotStarted: 0,
            };
        },

        computed: {
            pluralProjects: function() {
                return this.numberInProgress == 1 ? 'project' : 'projects';
            }
        },

        methods: {
            clickedCompact: function() {
                this.expand = false;
            },

            clickedExpand: function() {
                this.expand = true;
            },

            registerEvents: function() {
                var vm = this;
                Bus.$on('project-updated', function (response) {
                    vm.projectUpdated(response);
                    return true;
                });
                Bus.$on('project-created', function (response) {
                    vm.projectCreated(response);
                    return true;
                });
                Bus.$on('project-deleted', function (response) {
                    vm.projectDeleted(response);
                    return true;
                });
            },

            projectCreated: function() {
                this.refresh();
            },

            projectDeleted: function() {
                this.refresh();
            },

            updateProjectCounts: function() {
                this.numberInProgress = 0;
                this.numberNotStarted = 0;
                for (var index in this.projects) {
                    var project = this.projects[index];
                    if (project.status === 'In progress') {
                        this.numberInProgress++;
                    }
                    else if (project.status === 'Not started') {
                        this.numberNotStarted++;
                    }
                }
            },

            projectUpdated: function(updatedProject) {
                for (var index in this.projects) {
                    var project = this.projects[index];
                    if (project.id == updatedProject.id) {
                        // Use Vue.set to get reactivity when changing the contents of an array
                        Vue.set(this.projects, this.projects.indexOf(project), updatedProject);
                        break;
                    }
                }

                this.updateProjectCounts();
            },

            /**
             * Get the available member roles.
             */
            getProjects: function() {
                this.projects = [];
                axios.get(`/api/projects`)
                    .then(response => {
                        this.loading = false;
                        this.error = false;
                        this.projects = _.sortBy(response.data, project => {
                            return project.name;
                        });
                        this.updateProjectCounts();
                    })
                    .catch(error => {
                        this.loading = false;
                        this.error = true;
                        this.updateProjectCounts();
                    });
            },

            refresh: function() {
                this.loading = true;
                this.getProjects();
            },
        }
    }
</script>
